import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {GetShipmentsOptions, ShipmentsService} from "../services/shipments.service";
import {Shipment} from "../services/shipment";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentEditModalComponent} from "../shipment-edit-modal/shipment-edit-modal.component";
import * as moment from "moment";
import {ShipmentRoutesService} from "../services/shipment-routes.service";

declare let NProgress: any;

@Component({
    providers: [ShipmentRoutesService],
    selector: 'app-shipping-missing-coordinates',
    templateUrl: './shipping-missing-coordinates.component.html',
    styleUrls: ['./shipping-missing-coordinates.component.sass'],
})
export class ShippingMissingCoordinatesComponent implements OnInit {

    shipments: Shipment[];

    constructor(public router: Router,
                public shipmentsService: ShipmentsService,
                public ngbModal: NgbModal,
                public activatedRoute: ActivatedRoute,
    ) {
    }

    ngOnInit() {
        this.loadShipments();
    }

    edit(shipment: Shipment) {
        const modalRef = this.ngbModal.open(ShipmentEditModalComponent, {size: 'xl'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment = shipment;
        modalRef.componentInstance.showAddress = true;
        modalRef.componentInstance.saved = (result) => {
            this.loadShipments();
        };
    }


    loadShipments() {
        /**
         * Grab order_reference from query
         */
        let options: GetShipmentsOptions = {isSearching: false};
        if (this.activatedRoute.snapshot.queryParams.hasOwnProperty('startDate') &&
            this.activatedRoute.snapshot.queryParams.hasOwnProperty('endDate')
        ) {
            options['startDate'] = moment(this.activatedRoute.snapshot.queryParams.startDate);
            options.dateField = 'shipping_date';
            options['endDate'] = moment(this.activatedRoute.snapshot.queryParams.endDate);
            options['all'] = true;
        }


        if (this.activatedRoute.snapshot.queryParams.hasOwnProperty('branch')
        ) {
            options['branch'] = this.activatedRoute.snapshot.queryParams.branch.split(';');
        }

        this.shipmentsService.getShipmentsWithMissingCoordinates(1, options).then((response) => {
            this.shipments = response.results;
        });
    }

    shouldShowBack(): boolean {
        return this.activatedRoute.snapshot.queryParams.hasOwnProperty('startDate') &&
            this.activatedRoute.snapshot.queryParams.hasOwnProperty('endDate')
    }

    back() {
        this.router.navigate(['/shipping-system'])
    }
}
